import styled from 'styled-components';
import { Ellipsis } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';

export const SearchResultWrapper = styled('div')`
  text-decoration: none;
`;

interface HasLight {
  light?: boolean;
}

interface SearchResult {
  active?: boolean;
}

export const SearchResultRow = styled('div')<SearchResult & HasLight>`
  position: relative;
  display: flex;
  height: 64px;
  border-bottom: 1px solid
    ${({ theme, light }) =>
      light ? theme.color.spaceGrayRGBA(0.1) : theme.color.whiteRGBA(0.1)};
  align-items: center;
  padding-bottom: ${({ theme }) => theme.x0spacePx}px;
  background-color: ${({ theme, active, light }) => {
    if (!active) {
      return light ? theme.color.paper : 'transparent';
    }
    return light ? theme.color.paper : theme.color.darkGrayRGBA(0.1);
  }};
  ${media.mdUp`
    &:hover {
      background-color: ${({ theme, light }) =>
        light ? theme.color.paperRGBA(0.9) : theme.color.darkGrayRGBA(0.1)};
    }
  `}
`;

export const DetailsColumn = styled('div')`
  padding-left: 12px;
  padding-top: 0px;
  width: 205px;
`;

export const MiscColumn = styled('div')`
  padding-top: 8px;
  width: 80px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const NameContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  width: 100%;
`;

export const Title = styled('h4')<HasLight>`
  margin: 0;
  ${Ellipsis};
  ${media.mdUp`
    ${({ theme }) => theme.typography.smallStrong};
  `}

  ${media.mdDown`
    ${({ theme }) => theme.typography.baseStrong};
  `}

  color: ${({ theme, light }) =>
    light ? theme.color.spaceGray : theme.color.white};
`;

export const UniqueSymbol = styled('p')<HasLight>`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.tiny};
  color: ${({ theme, light }) =>
    light ? theme.color.spaceGrayRGBA(0.8) : theme.color.whiteRGBA(0.5)};
`;
